import cn from 'classnames';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { IoIosCheckmark, IoIosWarning } from 'react-icons/io';

import Input from '../Input';

import styles from './styles.scss';

// TODO: remove deprecated
export default function InlineEdit({
    tag: Tag,
    id,
    label,
    error,
    indicatorPosition,
    successfully,
    autoComplete,
    className,
    onFocus,
    onBlur,
    ...rest
}) {
    const [focused, setFocused] = useState(false); // TODO: remove useless

    const Indicator =
        error || successfully ? (
            <div className={cn(styles.icon, styles.success, styles[indicatorPosition])}>
                {error && <IoIosWarning />}
                {successfully && <IoIosCheckmark />}
            </div>
        ) : null;

    const onInputFocus = (e) => {
        setFocused(true);

        if (onFocus) {
            onFocus(e);
        }
    };

    const onFieldBlur = (e) => {
        setFocused(false);

        if (onBlur) {
            onBlur(e);
        }
    };

    return (
        <div className={cn(styles.root, className)}>
            {label && (
                <label htmlFor={id} className={styles.label}>
                    {label}
                </label>
            )}
            <div className={styles.inputContainer}>
                <Tag
                    id={id}
                    className={styles.inlineEditField}
                    size="normal"
                    autoComplete={autoComplete === 'off' ? Math.random() * 10 + '_autocomplete' : autoComplete}
                    onBlur={onFieldBlur}
                    onFocus={onInputFocus}
                    {...rest}
                />
                {Indicator}
            </div>
        </div>
    );
}

InlineEdit.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    tag: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
    error: PropTypes.any,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    className: PropTypes.string,
    indicatorPosition: PropTypes.oneOf(['start', 'end']),
    successfully: PropTypes.bool,
    autoComplete: PropTypes.oneOf(['on', 'off']),
};

InlineEdit.defaultProps = {
    type: 'text',
    tag: Input,
    indicatorPosition: 'start',
    successfully: false,
};
